export const partiType = {
  Client: "client",
  Vendor: "vendor",
};
